import styled from 'styled-components';

export const LabelWithTooltipField = styled.div`
	display: flex;
	flex-direction: column-reverse;
	gap: 4px;
`;

export const GuestUserField = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
`;

// Reserves vertical space for the design-system TextField's error line so
// toggling a required-field error on/off does not shift sibling rows below.
// Height covers label (~20px) + large input (~56px) + error text (~20px).
export const FormFieldSlot = styled.div`
	width: 100%;
`;
